<!-- Customer History Dialog -->
<div class="history-dialog">
  <!-- Filter Chips -->
  <div class="filter-chips">
    <div
      class="filter-badge filter-badge-all"
      [class.filter-badge-active]="selectedFilter() === 'all'"
      (click)="toggleFilter('all')"
    >
      <i class="pi pi-list"></i>
      <span class="badge-number">{{ filterStats().all }}</span>
      <span class="badge-label">All</span>
    </div>
    <div
      class="filter-badge filter-badge-user"
      [class.filter-badge-active]="selectedFilter() === 'user'"
      (click)="toggleFilter('user')"
    >
      <i class="pi pi-user"></i>
      <span class="badge-number">{{ filterStats().user }}</span>
      <span class="badge-label">User</span>
    </div>
    <div
      class="filter-badge filter-badge-system"
      [class.filter-badge-active]="selectedFilter() === 'system'"
      (click)="toggleFilter('system')"
    >
      <i class="pi pi-cog"></i>
      <span class="badge-number">{{ filterStats().system }}</span>
      <span class="badge-label">QPilot</span>
    </div>
  </div>

  <!-- Loading State - Skeleton -->
  @if (loading()) {
    <div class="skeleton-list">
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <div class="skeleton-item">
          <p-skeleton shape="circle" size="2rem" />
          <div class="skeleton-content">
            <div class="skeleton-header">
              <p-skeleton width="5rem" height="1.5rem" borderRadius="1rem" />
              <p-skeleton width="8rem" height="1rem" />
            </div>
            <p-skeleton width="100%" height="1rem" />
            <p-skeleton width="6rem" height="0.75rem" />
          </div>
        </div>
      }
    </div>
  }

  <!-- Error State -->
  @if (error() && !loading()) {
    <div class="error-container">
      <i class="pi pi-exclamation-triangle"></i>
      <p>{{ error() }}</p>
    </div>
  }

  <!-- Empty State -->
  @if (!loading() && !error() && history().length === 0) {
    <div class="empty-container">
      <i class="pi pi-history"></i>
      <p>No history entries found</p>
    </div>
  }

  <!-- History List - Simple custom layout -->
  @if (!loading() && !error() && history().length > 0) {
    <div class="history-list">
      @for (entry of history(); track entry.id) {
        <div class="history-item" [class.is-error]="isError(entry)">
          <div
            class="item-marker"
            [style.background-color]="getEntryColor(entry)"
          >
            <i [class]="getEntryIcon(entry)"></i>
          </div>
          <div class="item-content">
            <div class="item-header">
              <p-tag
                [value]="entry.eventVerb || entry.eventType"
                [severity]="getEntrySeverity(entry)"
                [rounded]="true"
              />
              <span class="item-date">
                {{ formatDate(entry.eventUtc) }}
              </span>
            </div>
            <p
              class="item-description"
              [innerHTML]="entry.description || entry.eventType"
            ></p>
            <span class="item-author">
              @if (isSystemOriginator(entry)) {
                <i class="pi pi-cog"></i>
              } @else {
                <i class="pi pi-user"></i>
              }
              {{ entry.originatorFormatted }}
            </span>
          </div>
        </div>
      }
    </div>
  }
</div>
